import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7e6aa741"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "sales-area-tree-container"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'SalesAreaTreeModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    currentAdcode: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const treeRef = ref();
    const salesAreaTree = ref([]);
    const selectedAreas = ref([]);
    const treeProps = {
      children: 'children',
      label: 'text'
    }; // 计算是否有选中项

    const hasSelected = computed(() => selectedAreas.value.length > 0); // 获取销售区域树数据

    function getSalesAreaTree() {
      return _getSalesAreaTree.apply(this, arguments);
    } // 处理树节点选择


    function _getSalesAreaTree() {
      _getSalesAreaTree = _asyncToGenerator(function* () {
        if (!props.currentAdcode) {
          ElMessage.warning('缺少区域代码');
          return;
        }

        try {
          const response = yield Axios.get('/admin/structure/getSalesManAreeTree.json', {
            params: {
              currentAdcode: props.currentAdcode
            }
          });

          if (response.data && Array.isArray(response.data)) {
            salesAreaTree.value = response.data;
          } else {
            ElMessage.error('获取销售区域树数据失败');
          }
        } catch (error) {
          console.error('获取销售区域树失败:', error);
          ElMessage.error('获取销售区域树失败');
        }
      });
      return _getSalesAreaTree.apply(this, arguments);
    }

    function handleCheck(data, checkedInfo) {
      // 获取所有选中的节点
      const checkedKeys = checkedInfo.checkedKeys;
      const checkedNodes = checkedInfo.checkedNodes;
      selectedAreas.value = checkedNodes.map(node => ({
        id: node.id,
        text: node.text
      }));
    } // 确认选择


    function confirm() {
      if (!hasSelected.value) {
        ElMessage.warning('请选择销售区域');
        return;
      }

      emit('success', selectedAreas.value);
      visible.value = false;
    } // 监听弹窗打开


    watch(() => props.modelValue, newVal => {
      if (newVal) {
        selectedAreas.value = [];
        getSalesAreaTree();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "选择销售区域",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "500px",
        "destroy-on-close": "",
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm,
          disabled: !_unref(hasSelected)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }, 8, ["disabled"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tree, {
          ref_key: "treeRef",
          ref: treeRef,
          data: salesAreaTree.value,
          props: treeProps,
          "node-key": "id",
          "default-expand-all": false,
          "highlight-current": true,
          "check-strictly": true,
          "show-checkbox": "",
          onCheck: handleCheck,
          class: "sales-area-tree"
        }, null, 8, ["data"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};